import { Button, Checkbox, Form, Input, message } from 'antd';
import { login } from '@model';
import { useState } from 'react';
import { useNavigate } from 'react-router';

const Login2page = () => {
    const [signing, setSigning] = useState(false);
    const navigate = useNavigate();

    return (
        <div className="lgn-body">
            <link href='/assets/style.css' type='text/css' rel='stylesheet' />
            <section className="ftco-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-4 login-box">
                            <div className="login-wrap p-0">
                                <Form onFinish={signIn} className='signin-form'>
                                    <Form.Item
                                        name="username"
                                        className='form-group'
                                        rules={[
                                            { required: true, message: "Username can not be empty" }
                                        ]}
                                    >
                                        <Input
                                            className="form-control"
                                            type="text"
                                            placeholder="Username"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="password"
                                        className='form-group'
                                        rules={[
                                            { required: true, message: "Password can not be empty" }
                                        ]}
                                    >
                                        <Input
                                            className="form-control"
                                            type="password"
                                            placeholder="Password"
                                        />
                                    </Form.Item>

                                    <div className="form-group">
                                        <Button
                                            loading={signing}
                                            type="primary"
                                            htmlType="submit"
                                            className="form-control btn btn-primary submit px-3"
                                        >
                                            Sign In
                                        </Button>
                                    </div>
                                    <div className="form-group d-md-flex">
                                        <div className="w-50">
                                            <Form.Item name="rememberMe" valuePropName='checked'>
                                                <label className="checkbox-wrap checkbox-primary">
                                                    Remember Me
                                                    <Checkbox />
                                                </label>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

    async function signIn(w: any) {
        console.log({...w})
        setSigning(true);
        login({ ...w })
            .then((c: any) => {
                if (c === "successful") {
                    navigate("/panel/dashboard");
                } else {
                    message.error(c);
                }
            })
            .catch((e: any) => {
                message.error("Error Ocurred");
            })
            .finally(() => {
                setSigning(false);
            });
    }
}

export default Login2page;
